export default "__VITE_ASSET__243a3c06__"